import { useMemo } from 'react';
import { useCurrentUser } from 'hooks/api/use-current-user';
import { ROLES } from 'constants/roles';

export const useReadOnly = (): boolean => {
  const {
    data: { authority },
  } = useCurrentUser() as { data: { authority?: string } };

  return useMemo(() => authority !== ROLES.SUPER_ADMIN, [authority]);
};
